import * as React from 'react'
import { useMemo } from 'react'
import {
  ContributionStatus,
  ContributionType,
} from '../../../../../generated/graphql'
import { useTheme } from '../../../../../hooks/theme.hook'
import { StyleProp, StyleSheet, View, ViewStyle } from 'react-native'
import { Text } from 'react-native-paper'
import { Icon } from '../../../../../@ui/typo/icon'
import {
  Icon3dChallenge,
  Icon3dEdit,
  Icon3dInquiry,
} from '../../../../../utils/meldd-icons'
import { createStyle } from '../../../../../contexts/global-styles.provider'
import { Row } from '../../../../../@ui/containers/grid/row'

interface ContributionsTypeCountProps {
  perspectiveId: string
  contributions: {
    contributionType: ContributionType
    status: ContributionStatus
  }[]
  navigateToContributions?: (contributionType: ContributionType) => void
}

export function ContributionsTypesCount(props: ContributionsTypeCountProps) {
  const styles = useStyles()
  const { contributions } = props
  const inquiryCount = useMemo(
    () =>
      contributions.filter(
        (c) => c.contributionType === ContributionType.Inquiry
      ).length,
    [contributions]
  )

  const challengeCount = useMemo(
    () =>
      contributions.filter(
        (c) => c.contributionType === ContributionType.Challenge
      ).length,
    [contributions]
  )
  const editCount = useMemo(
    () =>
      contributions.filter((c) => c.contributionType === ContributionType.Edit)
        .length,
    [contributions]
  )

  return (
    <Row justifyContent="center" alignItems="center" wrap={true}>
      <View style={styles.iconContainer}>
        <Icon3dInquiry
          size={16}
          onPress={() =>
            props.navigateToContributions?.(ContributionType.Inquiry)
          }
          mode={'text'}
          label={
            <Text variant={'titleSmall'} style={styles.count}>
              {inquiryCount}
            </Text>
          }
        />
      </View>
      <View style={styles.iconContainer}>
        <Icon3dChallenge
          size={16}
          onPress={() =>
            props.navigateToContributions?.(ContributionType.Challenge)
          }
          mode={'text'}
          label={
            <Text variant={'titleSmall'} style={styles.count}>
              {challengeCount}
            </Text>
          }
        />
      </View>
      <View style={styles.iconContainer}>
        <Icon3dEdit
          size={16}
          mode={'text'}
          onPress={() => props.navigateToContributions?.(ContributionType.Edit)}
          label={
            <Text variant={'titleSmall'} style={styles.count}>
              {editCount}
            </Text>
          }
        />
      </View>
    </Row>
  )
}

const useStyles = createStyle(({ theme, isMobile }) =>
  StyleSheet.create({
    count: {
      color: theme.colors.onSurface,
    },
    iconContainer: {
      paddingHorizontal: isMobile ? 6 : 16,
    },
  })
)
